const KanbanEmptyCell = () => {
  return (
    <div className="p-[10px] !h-auto w-full flex items-center justify-center budget-card-background" style={{ backgroundColor: "#D0DAE2" }}>
      <div className="bg-[#E5EBF0] border border-[#344054] rounded-lg p-4 w-full h-[220px] flex items-center justify-center">
        <span className="text-gray-400">-</span>
      </div>
    </div>
  );
};

export default KanbanEmptyCell;
